export default {
  setUsername(state, username) {
    state.username = username;
  },
  setLocal(state, local) {
    state.local = local;
  },
  setNominaPersonal(state, nominaPersonal) {
    state.nominaPersonal = nominaPersonal;
  },
  setFunciones(state, funciones) {
    state.funciones = funciones;
  },
  setSituacionesEmergentes(state, situaciones) {
    state.situacionesEmergentes = situaciones;
  },
  setSituacionesPreguntas(state, situaciones) {
    state.situacionesPreguntas = situaciones;
  },
  setFormasPruebas(state, formas) {
    state.formasPruebas = formas;
  },
  setUpdateSituacionesEmergentes(state, update) {
    state.updateSituacionesEmergentes = update;
  },
  setUpdateObservacionesPostulante(state, update) {
    state.updateObservacionesPostulante = update;
  },
  setTipoEvaluaciones(state, tipoEvaluaciones) {
    state.tipoEvaluaciones = tipoEvaluaciones;
  },
  setVigenciaSede(state, update) {
    state.vigenciaSede = update;
  },
  setBancos(state, bancos) {
    state.bancos = bancos;
  },
  setEstadoConfirmar(state, update) {
    state.estadoConfirmar = update;
  },
  setDiasRendicion(state, update) {
    state.diasRendicion = {
      ...state.diasRendicion,
      [state.local.fspCodigo]: update,
    }
  },
  setTiposObservacionesLocal(state, update) {
    state.tiposObservacionesLocal = update;
  },
  setTiposSitEmergentesExam(state, update) {
    state.tiposSitEmergentesExam = update;
  },
  setPruebas(state, { pruebas, fspCodigo }) {
    state.pruebas = {
      ...state.pruebas,
      ...{ [fspCodigo]: pruebas }
    };
  }
};
